<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <EventHeader :event="event" />
      <CardComponent>
        <h1 class="title">Manage Heats</h1>
        <p class="subtitle">{{ divisionWorkout }}</p>
        <b-checkbox v-model="data.hide" class="has-margin-top-5"
          >Hide Heats</b-checkbox
        >
        <div>
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="generate"
            >Generate</b-button
          >
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="addHeat"
            >Add Heat</b-button
          >
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="showTimeGenerateModal = true"
            >Auto-generate heat times</b-button
          >
          <b-button
            :disabled="loading"
            class="has-margin-right-10"
            type="is-primary"
            :loading="loading"
            @click="showCopyModal = true"
            >Copy heats from previous workout</b-button
          >
        </div>
        <div v-if="noHeats" class="has-margin-top-15">No heats found.</div>
        <div v-if="!noHeats" class="columns has-margin-top-15 is-multiline">
          <div
            v-for="(heat, index) in data.heats"
            :key="heat.heat"
            class="column is-4"
          >
            <div class="card has-equal-height">
              <div class="card-content">
                <p class="is-size-4 has-text-weight-bold is-uppercase">
                  Heat {{ heat.heat }}
                </p>
                <p
                  v-if="data.meta && data.meta[index]"
                  class="has-text-weight-bold is-uppercase"
                >
                  <span
                    class="has-margin-right-15"
                    style="position: relative; top: 5px"
                    >Time:</span
                  >
                  <BaseInput
                    v-model="data.meta[index].hour"
                    class="time-input"
                    type="number"
                    min="0"
                    max="23"
                    placeholder="HH"
                  /><span style="position: relative; top: 5px">:</span
                  ><BaseInput
                    v-model="data.meta[index].minute"
                    class="time-input"
                    type="number"
                    min="0"
                    max="59"
                    placeholder="MM"
                  />
                </p>
                <ul class="has-margin-top-15">
                  <draggable v-model="heat.lanes">
                    <li
                      v-for="(lane, laneindex) in heat.lanes"
                      :key="laneindex"
                      class="has-padding-top-5"
                      style="border-top: 1px solid #eee"
                    >
                      <table>
                        <tr>
                          <td class="has-padding-top-10">
                            <b-checkbox
                              v-model="selection"
                              :native-value="{ heat: heat.heat, lane: lane }"
                            />
                          </td>
                          <td style="padding-left: 5px">
                            <span>{{ laneindex + 1 }}. {{ lane.name }}</span>
                            <sup class="has-margin-left-5"
                              >#{{ lane.number }}</sup
                            >
                            <br />
                            <span style="color: #ccc">{{ lane.gymname }}</span>
                          </td>
                        </tr>
                      </table>
                    </li>
                  </draggable>
                </ul>
                <div v-if="heat.lanes.length === 0" class="has-text-centered">
                  <b-button
                    :disabled="loading"
                    class="has-margin-right-10"
                    type="is-primary"
                    @click="deleteHeat(heat)"
                    >Delete Heat</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="data.removed && data.removed.length > 0"
            class="column is-4"
          >
            <div class="card has-equal-height">
              <div class="card-content">
                <p class="is-size-4 has-text-weight-bold is-uppercase">
                  Removed Entries
                </p>
                <ul class="has-margin-top-15">
                  <li
                    v-for="(lane, laneindex) in data.removed"
                    :key="laneindex"
                    class="has-padding-top-5"
                    style="border-top: 1px solid #eee"
                  >
                    <table>
                      <tr>
                        <td class="has-padding-top-10">
                          <b-checkbox
                            v-model="selection"
                            :native-value="{ heat: -1, lane: lane }"
                          />
                        </td>
                        <td style="padding-left: 5px">
                          <span>{{ laneindex + 1 }}. {{ lane.name }}</span>
                          <sup class="has-margin-left-5"
                            >#{{ lane.number }}</sup
                          >
                          <br />
                          <span style="color: #ccc">{{ lane.gymname }}</span>
                        </td>
                      </tr>
                    </table>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
    <div class="footer">
      <b-select
        v-if="selection && selection.length > 0"
        v-model="action"
        placeholder="Select Action"
        class="inline-select"
      >
        <option>Move</option>
        <option>Delete</option>
      </b-select>
      <b-select
        v-if="action === 'Move' && selection && selection.length > 0"
        v-model="heat"
        placeholder="Select Heat"
        class="inline-select"
      >
        <option v-for="heat in heats" :key="heat" :value="heat">
          Heat {{ heat }}
        </option>
      </b-select>
      <b-button
        v-if="selection && selection.length > 0"
        :disabled="loading"
        class="has-margin-right-10"
        type="is-primary"
        @click="applyAction"
        >Apply</b-button
      >
      <b-button
        :disabled="loading"
        :loading="loading"
        type="is-primary"
        @click="saveChanges()"
        >Save Changes</b-button
      >
    </div>
    <b-modal :active.sync="showTimeGenerateModal" has-modal-card>
      <div class="modal-card" style="width: 400px">
        <header class="modal-card-head">
          <p class="modal-card-title">Auto-generate times</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Start Time">
            <b-timepicker v-model="starttime" inline> </b-timepicker>
          </b-field>
          <BaseInput
            v-model="interval"
            label="How many minutes is between each heat?"
            type="number"
            rules="required"
          />
        </section>
        <footer class="modal-card-foot">
          <b-button @click="showTimeGenerateModal = false"> Cancel </b-button>
          <b-button type="is-primary" @click="generateTimes">Generate</b-button>
        </footer>
      </div>
    </b-modal>
    <b-modal :active.sync="showCopyModal" has-modal-card>
      <div class="modal-card" style="width: 400px">
        <header class="modal-card-head">
          <p class="modal-card-title">Copy heats from previous workout</p>
        </header>
        <section class="modal-card-body">
          <BaseSelect
            v-model="workoutIdToCopy"
            label="Choose Workout to copy from"
            :rules="``"
          >
            <option
              v-for="workout in getPreviousWorkouts"
              :key="workout._id"
              :value="workout._id"
            >
              {{ workout.name }}
            </option>
          </BaseSelect>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="showCopyModal = false"> Cancel </b-button>
          <b-button type="is-primary" @click="copyHeats">Copy</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addMinutes } from 'date-fns'
import draggable from 'vuedraggable'
import EventHeader from '@/components/EventHeader'
import CardComponent from '@/components/CardComponent'
import BaseSelect from '@/components/BaseSelect'
import Filters from '@/mixins/filters'
import EventWorkoutApi from '@/api/event-workout'
import LeaderboardApi from '@/api/leaderboard'

export default {
  name: 'ManageHeats',
  components: {
    CardComponent,
    EventHeader,
    draggable,
    BaseSelect,
  },
  mixins: [Filters],
  data() {
    return {
      search: '',
      initialized: false,
      data: {},
      workout: {},
      division: {},
      heats: [],
      heat: {},
      action: 'Move',
      selection: [],
      loading: false,
      showTimeGenerateModal: false,
      starttime: '',
      interval: 10,
      showCopyModal: false,
      workoutIdToCopy: '',
    }
  },
  computed: {
    ...mapGetters(['event']),
    getPreviousWorkouts() {
      if (this.division && this.division.workouts) {
        let index = this.division.workouts.indexOf(this.workout)
        if (index > -1) {
          return this.division.workouts.slice(0, index)
        }
      }

      return []
    },
    noHeats() {
      return (
        this.data === null ||
        !this.data.heats ||
        (this.data.heats && this.data.heats.length === 0)
      )
    },
    divisionWorkout() {
      let result = ''
      if (this.division.entrytype) {
        if (this.division.gender && this.division.gender !== '') {
          result = `${this.workout.name} (${this.division.entrytype} - ${this.division.category} - ${this.division.gender})`
        } else {
          result = `${this.workout.name} (${this.division.entrytype} - ${this.division.category})`
        }
      }
      return result
    },
  },
  async created() {
    this.division = await EventWorkoutApi.getDivision(
      this.$route.params.divisionid
    )
    this.workout = this.division.workouts.find(
      (workout) => workout._id === this.$route.params.id
    )
    await this.loadData()
    this.initialized = true
  },
  methods: {
    deleteHeat(heat) {
      this.data.heats = this.data.heats.filter((item) => item !== heat)
      this.data.heats.forEach((item, index) => {
        item.heat = index + 1
      })
    },
    async copyHeats() {
      let result = await LeaderboardApi.getSavedHeats(
        this.division.event,
        this.division.entrytype,
        this.division.category,
        this.division.gender,
        this.workoutIdToCopy
      )
      if (result === null) {
        this.$buefy.toast.open({
          message: 'No heats available for this workout.',
          position: 'is-top',
          type: 'is-error',
        })
      } else {
        if (!this.data) {
          this.data = {}
        }
        this.data.meta = []

        this.data.event = this.division.event
        this.data.entrytype = this.division.entrytype
        this.data.category = this.division.category
        this.data.gender = this.division.gender
        this.data.workout = this.workout.name
        this.data.workoutid = this.$route.params.id
        this.data.heats = result.heats
        result.heats.forEach(() => {
          this.data.meta.push({ hour: '', minute: '' })
        })
        this.data.removed = []
        this.selection = []
        this.$buefy.toast.open({
          message:
            'Heats copied successfully. Remember to SAVE to apply changes.',
          position: 'is-top',
          type: 'is-success',
        })
        this.showCopyModal = false
      }
    },
    generateTimes() {
      this.data.heats.forEach((heat, index) => {
        this.data.meta[index].hour = this.starttime.getHours()
        this.data.meta[index].minute = this.starttime.getMinutes()
        this.starttime = addMinutes(this.starttime, this.interval)
      })
      this.showTimeGenerateModal = false
    },
    addHeat() {
      this.data.heats.forEach((item) => {
        item.heat++
      })
      var newheat = JSON.parse(JSON.stringify(this.data.heats[0]))
      newheat.heat = 1
      newheat.lanes = []
      this.data.heats.unshift(newheat)
    },
    async generate() {
      this.loading = true
      await LeaderboardApi.generateHeats(
        this.division.event,
        this.division.entrytype,
        this.division.category,
        this.division.gender,
        this.workout.name,
        this.$route.params.id
      )
      await this.loadData()
      this.$buefy.toast.open({
        message: 'Heats generated successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.loading = false
    },
    async saveChanges() {
      this.loading = true
      await LeaderboardApi.updateHeats(this.data)
      await this.loadData()
      this.$buefy.toast.open({
        message: 'Heats updated successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.loading = false
    },
    async applyAction() {
      if (this.action === 'Move') {
        this.doMove()
      } else {
        this.doDelete()
      }
    },
    async doMove() {
      let heats = this.data.heats
      let removed = this.data.removed
      this.selection.forEach((item) => {
        let heat = heats.find((heat) => heat.heat === item.heat)
        let insert = false
        if (heat) {
          heat.lanes = heat.lanes.filter((l) => l !== item.lane)
          if (heat.heat > this.heat) {
            insert = true
          } else {
            insert = false
          }
        } else {
          removed = removed.filter((lane) => lane !== item.lane)
        }
        let newheat = heats.find(
          (heat) => heat.heat === parseInt(this.heat, 10)
        )
        if (insert) {
          newheat.lanes.unshift(item.lane)
        } else {
          newheat.lanes.push(item.lane)
        }
      })
      this.data.heats = heats
      this.data.removed = removed
      this.selection = []
      this.$buefy.toast.open({
        message:
          'Lanes has been moved successfully. Remember to SAVE to apply changes.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    async doDelete() {
      let removed = this.data.removed
      this.selection.forEach((item) => {
        if (item.heat) {
          let heat = this.data.heats.find((heat) => heat.heat === item.heat)
          if (heat) {
            heat.lanes = heat.lanes.filter((l) => l !== item.lane)
          }
          if (!removed) {
            removed = []
          }
          let found = removed.find((l) => l === item.lane)
          if (!found) {
            removed.push(item.lane)
          }
        }
      })
      this.data.removed = removed
      this.selection = []
      this.$buefy.toast.open({
        message:
          'Lanes has been moved to the Removed Entries block at the end of the list of heats. Remember to SAVE to apply changes.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    async loadData() {
      let result = await LeaderboardApi.getSavedHeats(
        this.division.event,
        this.division.entrytype,
        this.division.category,
        this.division.gender,
        this.$route.params.id
      )
      this.data = result
      if (!this.data) {
        this.data = {
          meta: [],
          removed: [],
        }
      }
      if (!this.data.meta) {
        this.data.meta = []
      }

      if (result !== null) {
        if (
          this.data.meta &&
          this.data.meta.length === 0 &&
          result.heats.length > 0
        ) {
          result.heats.forEach(() => {
            this.data.meta.push({ hour: '', minute: '' })
          })
        }

        this.heats = result.heats.map((item) => item.heat)
        this.heat = this.heats[0]
      }
    },
  },
}
</script>

<style scoped>
.time-input {
  display: inline-block;
  width: 70px;
}

.has-equal-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footer {
  position: fixed;
  height: 50px;
  background: #000;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
}

.inline-select {
  display: inline-block;
  margin-right: 10px;
}
</style>